import styled from 'styled-components';
import { Box, Typography, Button } from '@mui/material';
import { fontSizes } from '../../../layouts/fontSizes';
import pallet from '../../../layouts/pallet';

export const FormHeader = styled(Typography)({
  fontSize: `${fontSizes.h4} !important`,
  fontWeight: 'bold',
  marginLeft: '3% !important',
  marginTop: '16px !important'
});

export const StyledButton = styled(Button).attrs({
  variant: 'contained',
  color: 'primary'
})({});

export const OutlinedButton = styled(Button).attrs({
  variant: 'outlined',
  size: 'small'
})({});

export const ButtonContainer = styled(Box)({
  display: 'flex',
  alignItems: 'flex-end',
  justifyContent: 'flex-end',
  gap: 16,
  width: '100%'
});

export const ViewEditWrapper = styled(Box)({
  display: 'flex',
  alignItems: 'end',
  justifyContent: 'space-between',
  marginBottom: 16
});

export const AddMoreButton = styled(Button).attrs({
  variant: 'contained',
  color: 'primary'
})({
  width: '100%',
  maxWidth: '200px',
  borderRadius: '6px !important',
  textWrap: 'nowrap',
  fontSize: '15px !important',
  color: `${pallet.primary} !important`,
  backgroundColor: `${pallet.hoverBlue} !important`
});

export const MarkBookTableHeader = styled(Box)({
  backgroundColor: pallet.grayBackground,
  display: 'flex',
  borderBottom: `1px solid ${pallet.tableHeaderBorder}`,
  padding: '10px 8px',
  borderRadius: '9px',
  gap: '8px',
  marginBottom: '4px'
});

export const MarkBookTableHeaderItem = styled(Typography)({
  flex: 1,
  fontWeight: '700 !important',
  color: `${pallet.formLabelText} !important`,
  fontSize: '14px !important'
});
